import React from 'react';
import PropTypes from 'prop-types';
import TrashIcon from '@common/images/trash-icon.svg';
import {Image} from '@learningblocks/shared-components';

/**
 * RemoveIcon: Component display the Remove NodeOption Icon.
 */
export function RemoveIcon({removeOption}) {
  return <Image src={TrashIcon} alt='removeIcon' onClick={removeOption} />;
}

RemoveIcon.propTypes = {
  /**
   * Function involked when clicked on
   * the icon
   */
  removeOption: PropTypes.func.isRequired,
};

RemoveIcon.defultProps = {};
